import { render, staticRenderFns } from "./Groups.vue?vue&type=template&id=c1b9f334&scoped=true&"
import script from "./Groups.vue?vue&type=script&lang=js&"
export * from "./Groups.vue?vue&type=script&lang=js&"
import style0 from "./Groups.vue?vue&type=style&index=0&id=c1b9f334&lang=scss&scoped=true&"
import style1 from "./Groups.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1b9f334",
  null
  
)

export default component.exports